import Vue from 'vue'

export const state = {
  loaderMessage: ''
}

export const getters = {
  loaderMessage: state => state.loaderMessage
}

export const mutations = {
  SET_USER_SEARCH_RESULT(state, result) {
    state.userSearch = result
  },
  SET_LOADER_MSG(state, value){
    state.loaderMessage = value
  }
}

export const actions  = {
  message({ commit }, { title, text, type }) {
    Vue.prototype.$notify({
      group: 'foo',
      title,
      text,
      type,
    })
  },
  loaderMessage({ commit }, text){
    commit('SET_LOADER_MSG', text)
  }
}